import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const ExternalCamera = ({ onOpen, onClose, fromSettingsClose }) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup
             id="receivesets-externalcamera-popup"
                title={t('receiveSets.ReceiveSetsLoc.AddSetsLists.camera')}
                onClose={fromSettingsClose ? fromSettingsClose : onClose}
                img={AlertCircleOutline}
                id={'receiveSets-externalCamera-popup'}
            >
                <UnsavedChangesDiv divHeight={'140px'}>
                    <Text
                        flexGrow={'1'}
                        height={'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                    >
                        {t(
                            'receiveSets.ReceiveSetsLoc.AddSetsLists.wouldYouLikeToUseDevice'
                        )}
                    </Text>
                    <DesktopWrap flexDirection="row-reverse">
                        <Button
                        id={'receiveSets-notifications-externalCameraOkButton'}
                            show={true}
                            width={'80px'}
                            height={'38px'}
                            //primary={true}
                            variant={ButtonStyles?.primary}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onOpen}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>OK</div>
                        </Button>

                        <Button
                        id={'receiveSets-notifications-externalCameraCancelButton'}
                            show={true}
                            //cancel={true}
                            variant={ButtonStyles?.cancel}
                            width={'100px'}
                            height={'38px'}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t('common.cancelButton')}
                            </div>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default ExternalCamera;
